import "./groupedProductItem.css";

const GroupedProductItem = ({
  product,
  language,
  getProductName,
  updateQuantity,
  removeFromCart,
}) => {
  return (
    <div
      key={product.id}
      style={{
        border: "1px solid #ddd",
        borderRadius: "8px",
        padding: "15px",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <div>
        <h3 style={{ margin: "0 0 10px 0" }}>
          {getProductName(product, language)}
        </h3>
        {/* <p style={{ margin: "0 0 10px 0" }}>Provider: {product.provider}</p> */}
      </div>

      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <input
          type="number"
          value={product.quantity}
          onChange={(e) => updateQuantity(product.id, parseInt(e.target.value))}
          min="1"
          style={{ width: "50px", padding: "5px" }}
        />
        <button onClick={() => removeFromCart(product.id)} className="delbutton">
          Remove
        </button>
      </div>
    </div>
  );
};

export default GroupedProductItem;
